import { connect } from 'react-redux';

import {
  getOfficesShortList,
  getPublicZoneList,
} from '../../Offices/officesActions';
import { getMasterSubTasks } from '../MasterSubTasks/masterSubTasksActions';
import EmtithalMasterTasks from './EmtithalMasterTasks';
import {
  addEmtithalMasterTask,
  editEmtithalMasterTask,
  getEmtithalMasterTasks,
} from './emtithalMasterTasksActions';

const mapStateToProps = state => ({
  emtithalMasterTasksList: state.task.emtithalMasterTasksList,
  isLoading: state.task.emtithalMasterTasksLoading,
  totalTasksCount: state.task.emtithalMasterTasksCount,
  pageSize: state.task.emtithalMasterTasksPageSize,
  publicZoneList: state.office.publicZoneList,
  officesShortList: state.office.officesShortList,
  officesShortList2: state.office.officesShortList2,
  addTaskLoading: state.task.addEmtithalMasterTaskLoading,
  masterSubTasksList: state.task.masterSubTasksList,
  masterSubTasksLoading: state.task.masterSubTasksLoading,
});

const mapDispatchToProps = dispatch => ({
  getEmtithalMasterTasks: params => dispatch(getEmtithalMasterTasks(params)),
  editEmtithalMasterTask: params => dispatch(editEmtithalMasterTask(params)),
  addEmtithalMasterTask: params => dispatch(addEmtithalMasterTask(params)),
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getMasterSubTasks: params => dispatch(getMasterSubTasks(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmtithalMasterTasks);
